// src/App.js
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import WhatsAppPulseButton from './components/WhatsAppPulseButton.js';

// Page Components
import HomePage from './components/HomePage.js';
import AboutPage from './components/AboutPage.js';
import ServicesPage from './components/ServicesPage.js';
import ContactPage from './components/ContactPage.js';
import ThankYouPage from './components/ThankYouPage.js';
import ScrollToTop from './components/ScrollToTop.js'; 

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          {/* Global SEO META TAGS - Can be overridden by individual pages */}
          <Helmet>
            <title>Webbloom - Modern Web Development Company in Mumbai, India | Web Development Company in Mumbai</title>
            <meta name="description" content="Webbloom is a modern web development company specializing in creating powerful, scalable, and visually engaging digital solutions. We offer professional website development, WordPress design, custom web applications, mobile app development, and SEO services to help businesses grow online. Our team focuses on delivering responsive, fast, and SEO-friendly websites tailored to meet your business goals and enhance your online presence." />
            <meta name="keywords" content="Web Development Company in Mumbai, Website Development Services in Mumbai,Custom Web Development in mumbai, Professional Web Developer in mumbai, Responsive Website Design company in mumbai, Mobile App Development Company in mumbai, SEO Services Company in mumbai, WordPress Development Services in mumbai,HTML Website Development in mumbai,Best Web Development Company in India,Affordable Web Design Services in Mumbai,Business Website Development in mumbai, E-commerce Website Development in mumbai, Web Application Development in mumbai, CMS Development Services in mumbai, Front-end Development Services in mumbai, Back-end Development Services in mumbai, Full-stack Development Services in mumbai, Custom Web Application Development in mumbai, Web Portal Development Services in mumbai, API Development Services in mumbai, Website Maintenance and Support Services in mumbai" />
            {/* <meta property="og:title" content="Webbloom - Modern Web Development Company in Mumbai, India" />
            <meta property="og:description" content="Webbloom is a modern web development company specializing in creating powerful, scalable, and visually engaging digital solutions. We offer professional website development, WordPress design, custom web applications, mobile app development, and SEO services to help businesses grow online. Our team focuses on delivering responsive, fast, and SEO-friendly websites tailored to meet your business goals and enhance your online presence." /> */}
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://webbloom.in/" />
            <meta property="og:image" content="https://webbloom.in/" />
          </Helmet>

          <Header />
          
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact-us" element={<ContactPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
            </Routes>
          </main>
          
          <Footer />
          <WhatsAppPulseButton />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;